import { DOCUMENT_RULES_UI_SECTIONS } from '../../model/quality.constant';
import { SubjectLayout } from '../models/1004/subject.layout';
import { NeighborhoodLayout } from '../models/1004/neighborhood.layout';
import { ImprovementsLayout } from '../models/1004/improvements.layout';
import { SalesApproachLayout } from '../models/1004/sales-approach.layout';
import { CostApproachLayout } from '../models/1004/cost-approach.layout';
import { IncomeApproachLayout } from '../models/1004/income-approach.layout';
import { ReconciliationLayout } from '../models/1004/reconciliation.layout';
import {
	Subject1073Layout,
	Neighborhood1073Layout,
	ProjectInformation1073Layout,
	ProjectAnalysis1073Layout,
	UnitDescription1073Layout,
	SalesApproach1073Layout
} from '../models/1073';
import { ProjectAnalysis1075Layout, UnitDescription1075Layout } from '../models/1075';
import { Improvements2055Layout } from '../models/2055/improvements.layout';
import { ArrivalLayout } from '../models/cvds/arrival.layout';
import { SiteLayout } from '../models/cvds/site.layout';

export class ReviewSectionsPages {
	pages = {
		1004: {
			subject: {
				layout: SubjectLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: NeighborhoodLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			improvements: {
				layout: ImprovementsLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.IMPROVEMENTS
			},
			salesapproach: {
				layout: SalesApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			costapproach: {
				layout: CostApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.COSTAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		1073: {
			subject: {
				layout: Subject1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: Neighborhood1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			projectinformation: {
				layout: ProjectInformation1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTINFORMATION
			},
			projectanalysis: {
				layout: ProjectAnalysis1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTANALYSIS
			},
			unitdescription: {
				layout: UnitDescription1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.UNITDESCRIPTION
			},
			salesapproach: {
				layout: SalesApproach1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		1075: {
			subject: {
				layout: Subject1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: Neighborhood1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			projectinformation: {
				layout: ProjectInformation1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTINFORMATION
			},
			projectanalysis: {
				layout: ProjectAnalysis1075Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.PROJECTANALYSIS
			},
			unitdescription: {
				layout: UnitDescription1075Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.UNITDESCRIPTION
			},
			salesapproach: {
				layout: SalesApproach1073Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		2055: {
			subject: {
				layout: SubjectLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			neighborhood: {
				layout: NeighborhoodLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.NEIGHBORHOOD
			},
			improvements: {
				layout: Improvements2055Layout,
				rules: DOCUMENT_RULES_UI_SECTIONS.IMPROVEMENTS
			},
			salesapproach: {
				layout: SalesApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SALESAPPROACH
			},
			costapproach: {
				layout: CostApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.COSTAPPROACH
			},
			incomeapproach: {
				layout: IncomeApproachLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.INCOMEAPPROACH
			},
			reconciliation: {
				layout: ReconciliationLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.RECONCILIATION
			}
		},
		cvds: {
			arrival: {
				layout: ArrivalLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			site: {
				layout: SiteLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			}
		},
		'BPOInterior': {
			arrival: {
				layout: ArrivalLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			},
			site: {
				layout: SiteLayout,
				rules: DOCUMENT_RULES_UI_SECTIONS.SUBJECT
			}
		}
	};
}
